import { render, staticRenderFns } from "./IconSteps.vue?vue&type=template&id=5270c906&scoped=true"
import script from "./IconSteps.vue?vue&type=script&lang=js"
export * from "./IconSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270c906",
  null
  
)

export default component.exports